if (localStorage.getItem('cookies')) {
    $('.sticky').attr('style', 'display: none !important');
} else {
    $('.sticky').removeAttr('style');
}

$(window).on('load', function () {
    $('.loader').fadeOut('slow');
    setTimeout(function () {
        $('.wrapper').removeClass('hide-wrapper');
    }, 0);
});

let timer = 0;

function set_interval() {
    timer = setInterval("auto_reload()", 60000);
}

function reset_interval() {
    if (timer != 0) {
        clearInterval(timer);
        timer = 0;
        timer = setInterval("auto_reload()", 60000);
    }
}

function auto_reload() {
    location.reload();
}

function isJson(str) {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

function getUrlParameter(sParam) {
    let sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function update_cart() {
    $.ajax({
        type: 'GET',
        url: '/update_cart',
        data: {
            lang: $('.language-main-header__item._active').attr('data-lang')
        },
        success: function (response) {
            $('.loader').removeAttr('style');
            // $('.wrapper').addClass('hide-wrapper');
            $('.loader').fadeOut('slow');

            let responseHtml = JSON.parse(response).html;
            let responseTotal = JSON.parse(response).total;
            let responseCountProducts = JSON.parse(response).count_products;

            $('.cart-header').remove();
            $('.search-header').after(responseHtml);

            $('.cart').find('._subtotal').find('.list-cart__name').text(productsLabel + '(' + responseCountProducts + ')');

            $('.cart').find('._subtotal').find('.list-cart__value').text(responseTotal.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');
            $('.cart').find('._total').find('.list-cart__value').text(responseTotal.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');

            if (responseCountProducts == '0') {
                $('._cart_title').remove();
                $('.cart__wrapper').remove();
                $('.cart__container').html('<h1 class="cart__title _title _empty_cart">' + basketIsEmpty + '</h1>');
            }

            $('.cart-header').addClass('ajax_add');

            setTimeout(function () {
                $('.wrapper').removeClass('hide-wrapper');
            }, 0);

            return false;
        }
    });
}

function delete_from_cart(item) {
    $.ajax({
        type: 'POST',
        url: '/delete_from_cart',
        data: {
            'productId': item.attr('data-key')
        },
        success: function () {
            $(item).parent().remove();
        }
    }).done(function () {
        update_cart();
    });
}

function update_product_amount(current_element, productKey, value) {
    $.ajax({
        type: 'POST',
        url: '/update_product_amount',
        data: {
            productKey: productKey,
            amount: value
        },
        success: function (response) {
            if (!$('.top-cart-header').is(':visible')) {
                current_element.parent().next().text(JSON.parse(response).price.toLocaleString(undefined, {
                    minimumFractionDigits: 2
                }).replace(',', '.') + ' lei');

                current_element.parent().parent().next().text(JSON.parse(response).price.toLocaleString(undefined, {
                    minimumFractionDigits: 2
                }).replace(',', '.') + ' lei');
            }

            $('._subtotal').find('.list-cart__value').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');

            $('._subtotal').find('.list-cart__name').text(productsLabel + ' (' + JSON.parse(response).count_products + ')');

            $('._subtotal').find('.list-cart-header__value').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');

            $('._subtotal').find('.list-cart-header__name').text(productsLabel + ' (' + JSON.parse(response).count_products + ')');

            $('.intro-cart-header__count').text(JSON.parse(response).count_products);

            $('._total').find('.list-cart__value').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');

            $('._total').find('.list-cart-header__value').text(JSON.parse(response).total.toLocaleString(undefined, {
                minimumFractionDigits: 2
            }).replace(',', '.') + ' lei');
        }
    });
}

$(document).mousemove(function () {
    reset_interval();
});

$(document).on('click', function () {
    reset_interval();
});

$(document).on('keypress', function () {
    reset_interval();
});

$(document).scroll(function () {
    reset_interval();
});

function regenerate_contacts_recaptcha() {
    let tokenValue = $('input[name="token"]');

    setInterval(function () {
        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                tokenValue.val('');
                tokenValue.val(token);
            });
        });
    }, 60000);
}

function initMap() {
    const myLatLng = {
        lat: 47.7861506192701,
        lng: 27.91617105474848
    };
    const map = new google.maps.Map(document.getElementById("map"), {
        zoom: 16,
        center: myLatLng
    });

    new google.maps.Marker({
        position: myLatLng,
        map,
        title: mapAddress,
    });
}

function reset_filters() {
    $('.price-filter__input').each(function () {
        if ($(this).attr('id') != 'start-price' && $(this).attr('id') != 'end-price') {
            $(this).removeAttr('value');
        }
    });

    $('.checkbox__input').each(function () {
        $(this).removeAttr('checked');
    });
}

$(document).ready(function () {
    $(document).on('click', '.header__logo', function () {
        let currentLanguage = '';
        reset_filters();

        $('.language__item').each(function () {
            let currentElement = $(this);

            if (currentElement.hasClass('_active')) {
                currentLanguage = currentElement.attr('data-lang');
            }
        });

        $.ajax({
            type: 'POST',
            url: '/clear_filters',
            success: function () {
                window.location.href = '/' + currentLanguage;
            }
        });
    });

    $('.search__select').each(function () {
        if ($(this).find('.select__options div').length == 0) {
            $(this).parent().remove();
        }
    });

    $('.multylist-filter').each(function () {
        if ($(this).find('.list-filter__item').length == 0) {
            $(this).parent().parent().remove();
        }
    });

    $(document).on('click', '#show_more', function () {
        let currentCounter = 0;
        let hiddenElements = 0;

        $('.catalog__item').each(function () {
            if (!$(this).is(':visible') && currentCounter <= limitCode) {
                $(this).removeAttr('style');
                currentCounter = currentCounter + 1;
            }
        });

        $('.catalog__item').each(function () {
            if (!$(this).is(':visible')) {
                hiddenElements = hiddenElements + 1;
            }
        });

        if ((hiddenElements - 1) <= 0) {
            $(this).remove();
        }
    });

    $(document).on('click', '._filter-reset', function () {
        reset_filters();
    });

    $(document).on('focus', '#start-price', function () {
        $(this).val(fromPlaceholder);
    });

    $(document).on('focusout', '#start-price', function () {
        if (!$.isNumeric($(this).val())) {
            $(this).val(minPrice);
        }
    });

    $(document).on('focus', '#end-price', function () {
        $(this).val(toPlaceholder);
    });

    $(document).on('focusout', '#end-price', function () {
        if (!$.isNumeric($(this).val())) {
            $(this).val(maxPrice);
        }
    });

    const priceSlider = document.getElementById('price-slider');

    if (priceSlider) {
        if (typeof startPrice !== 'undefined' && typeof endPrice !== 'undefined') {

            if (endPrice == 999999999) {
                endPrice = maxPrice;
            }

            noUiSlider.create(priceSlider, {
                start: [startPrice, endPrice],
                connect: true,
                range: {
                    'min': [0],
                    'max': [999999999]
                }
            });
        } else {
            noUiSlider.create(priceSlider, {
                start: [minPrice, maxPrice],
                connect: true,
                range: {
                    'min': [0],
                    'max': [999999999]
                }
            });
        }

        const priceStart = document.getElementById('start-price');
        const priceEnd = document.getElementById('end-price');
        const inputs = [priceStart, priceEnd];

        priceSlider.noUiSlider.on('update', function (values, handle) {
            inputs[handle].value = parseInt(values[handle]);
        });

        priceStart.addEventListener('change', function () { // при изменении меньшего значения в input - меняем положение соответствующего элемента управления
            priceSlider.noUiSlider.set([this.value, null]);
        });

        priceEnd.addEventListener('change', function () { // при изменении большего значения в input - меняем положение соответствующего элемента управления
            priceSlider.noUiSlider.set([null, this.value]);
        });

        $(document).on('click', '._filter-reset', function () {
            priceSlider.noUiSlider.set([0, 999999999]);
            $('.catalog__filter').submit();
        });
    }

    const priceSliderMob = document.getElementById('mob-price-slider');
    if (priceSliderMob) {
        noUiSlider.create(priceSliderMob, {
            start: [minPrice, maxPrice],
            connect: true,
            range: {
                'min': [0],
                'max': [999999999]
            }
        });

        const priceStart = document.getElementById('start-price-mob');
        const priceEnd = document.getElementById('end-price-mob');
        const inputs = [priceStart, priceEnd];

        priceSliderMob.noUiSlider.on('update', function (values, handle) {
            inputs[handle].value = parseInt(values[handle]);
        });

        priceStart.addEventListener('change', function () { // при изменении меньшего значения в input - меняем положение соответствующего элемента управления
            priceSliderMob.noUiSlider.set([this.value, null]);
        });

        priceEnd.addEventListener('change', function () { // при изменении большего значения в input - меняем положение соответствующего элемента управления
            priceSliderMob.noUiSlider.set([null, this.value]);
        });

        $(document).on('click', '._filter-reset', function () {
            priceSliderMob.noUiSlider.set([0, 999999999]);
            $('.catalog__filter').submit();
        });
    }

    $(document).on('click', '.car_type', function () {
        let currentElement = $(this).attr('data-value');

        $('.car_model').each(function () {
            if ($(this).attr('data-parent') != currentElement) {
                $(this).css('display', 'none');
            } else {
                $(this).removeAttr('style');
            }
        });
    });

    if ($('.card').length) {
        if ($('.products-slider__item').length <= '1') {
            $('.products-slider__arrow').css('display', 'none');
        }
    }

    if ($('.standart_options').length) {
        let $originalList = $('.standart_options').find('ul');
        let $firstList = $('#firstList');
        let $secondList = $('#secondList');
        let listLength = $originalList.find('li').length / 2;

        $originalList.children('li').each(function (index) {
            if (index <= listLength) {
                $firstList.append($(this).clone());
            } else {
                $secondList.append($(this).clone());
            }
        });

        $originalList.eq(0).css('display', 'none');
    }

    if ($('.contacts').length) {
        let tokenValue = $('input[name="token"]');

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                tokenValue.val('');
                tokenValue.val(token);
            });
        });

        regenerate_contacts_recaptcha();

        $('#contacts_form').on('submit', function (event) {
            if (!$('input[name="politics"]').is(':checked')) {
                event.preventDefault();
                toastr.error(acceptConditions);
                return false;
            }

            $(this).submit();
        });
    }

    if ($('#test_drive_form').length) {
        let tokenValue = $('input[name="token"]');

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                tokenValue.val('');
                tokenValue.val(token);
            });
        });

        regenerate_contacts_recaptcha();

        $('#test_drive_form').on('submit', function (event) {
            if (!$('input[name="politics"]').is(':checked')) {
                event.preventDefault();
                toastr.error(acceptConditions);
                return false;
            }

            $(this).submit();
        });
    }

    if ($('#offer_your_price').length) {
        let tokenValue = $('input[name="token"]');

        grecaptcha.ready(() => {
            grecaptcha.execute('6LfPmtYiAAAAACJofbUnJQGP7YnVi5Cc1JWIaAgB', {
                action: 'contact'
            }).then(token => {
                tokenValue.val('');
                tokenValue.val(token);
            });
        });

        regenerate_contacts_recaptcha();

        $('#offer_your_price').on('submit', function (event) {
            if (!$('input[name="politics"]').is(':checked')) {
                event.preventDefault();
                toastr.error(acceptConditions);
                return false;
            }

            $(this).submit();
        });
    }

    if ($('.main_banner').length <= '1') {
        $('.banner__arrow').css('display', 'none');
    }
});